// extracted by mini-css-extract-plugin
export default {"counterStyle":"CounterComponent_counterStyle__duueZ"};